// The MIT License (MIT)

// Copyright (c) 2014 Call-Em-All

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
import React from 'react'
import "./FooterStyle.css";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import whatsapp from "../images/whatsapp.webp";
import { NavLink } from 'react-router-dom';
const Footer = () => {
    const divStyle = {
        // borderRadius: '13px',
        width: '180px',

    };
    const divStyle2 = {
        // borderRadius: '13px',
        width: '150px',

    };
    return (
        <>
            <div className="mainFooter">

                <div className="blocks">

                    <div className="block1">
                        <div className="tab1">
                            <div className="address">
                                <p className="Addresshead"><b>OFFICE ADDRESS</b></p>
                                <p className="fullAddress">Office No. 312, Grohitam Premises, Opp. Dana Bazar, Sector - 19, Vashi, Navi Mumbai - 400 703</p>
                            </div>
                            <div className="implinks">
                                <p className="linkshead"><b>IMPORTANT LINKS</b></p>
                                <ul>
                                    <li><NavLink to="/about" style={({ isActive }) => ({ color: isActive ? 'black' : 'black', })}><p id='footlink'>About Us</p></NavLink></li>
                                    <li><NavLink to="/services" style={({ isActive }) => ({ color: isActive ? 'black' : 'black', })}><p id='footlink'>Services</p></NavLink></li>
                                    <li><NavLink to="/gallery" style={({ isActive }) => ({ color: isActive ? 'black' : 'black', })}><p id='footlink'>Gallery</p></NavLink></li>
                                    {/* <li><a href="https://documents-pratham-investments.cyclic.cloud/" target='blank'><p id='footlink'>Initiate Onboarding</p></a></li> */}
                                    <li><NavLink to="/testimonials" style={({ isActive }) => ({ color: isActive ? 'black' : 'black', })}><p id='footlink'>Testimonials</p></NavLink></li>
                                    <li><NavLink to="/calculators" style={({ isActive }) => ({ color: isActive ? 'black' : 'black', })}><p id='footlink'>Calculators</p></NavLink></li>
                                </ul>
                            </div>
                        </div>
                        <div className="tab1">
                            <div className="contactDetails">
                                <p className="contact1"><b>CONTACT US</b></p>
                                <div className="contactemail">
                                    <div>
                                        <MailOutlineIcon></MailOutlineIcon>
                                    </div>
                                    <div>
                                        <a href="mailto: contact@prathaminvestments.com" target="_blank" rel="noreferrer">contact@prathaminvestments.com</a>
                                    </div>
                                </div>
                                <div className="contactemail">
                                    <div>
                                        <CallOutlinedIcon></CallOutlinedIcon>
                                    </div>
                                    <div>
                                        <a href="tel: +91-992-034-1878">9920341878</a>
                                    </div>
                                </div>
                            </div>
                            <div className='block2'>
                                <div className="block2links">
                                    <div className="block2head"><b> DOWNLOAD MOBILE APP </b></div>
                                    <div className="googlebtn">
                                        <a href='https://play.google.com/store/apps/details?id=com.fin.mclientdesk&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank" rel="noreferrer"><div><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={divStyle} /></div></a>
                                    </div>
                                    <div className="applebtn">
                                        <a href="https://apps.apple.com/us/app/nj-client-desk/id592382044?itsct=apps_box_badge&amp;itscg=30200" target="_blank" rel="noreferrer"><div><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1358380800?h=d7511fffb221137136fde5a78328e670" alt="Download on the App Store" style={divStyle2} /></div></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

            </div>




            <a href=" https://wa.me/919920341878" target="_blank" rel="noreferrer">
                <div className="whatsapp">
                    <img src={whatsapp} alt="" className='icon' />
                </div>
            </a>
            {/* { Guy } */}
            {/* <div className="sticker">
   <a href="https://www.njindiaonline.com/etada/partintiate.fin?cmdAction=showMenu&njBrcode=76800" target="_blank" rel="noreferrer">
   <img src={ Banner } alt="" className='icon2'/>
   </a>
   </div> */}
          
            <div className="footerbelow">
                
                <div className="footerbelowinside">Disclaimer: Mutual Fund investments are subject to market risks, read all scheme related documents carefully.</div>
           
            </div>
            <div className="footerbelow">
                
                <div className="footerbelowinside">© Pratham Investments - All Rights Reserved.</div>
           
            </div>

            {/* <Outlet/> */}
        </>
    )
}

export default Footer
// Google Play and the Google Play logo are trademarks of Google LLC.